import { useState } from 'react';
import styles from './W_PaymentTreeDonate.module.css';
import W_PaymentActions from '../W_PaymentActions/W_PaymentActions';
import { useTimer } from '@/hooks/useTimer';
import { generateRequestId } from '@/utils/generators';
import C_PaySystems from '@/components/C_Collections/C_PaySystems/C_PaySystems';
import A_Input from '@/components/A_Atoms/A_Input/A_Input';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

const isAmountValid = (amount: string) => {
  const numAmount = Number(amount.replace(/\s/g, ''));
  return numAmount >= 1000 && numAmount <= 1000000 && amount.trim() !== '';
};

export default function W_PaymentTreeDonate() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const [requestId] = useState(generateRequestId());
  const [amount, setAmount] = useState('');
  const remainingTime = useTimer(15);

  const handleAmountChange = (value: string) => {
    setAmount(value);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h4 className={styles.title}>
          {t('payment.treeDonate.enterAmountTitle')}
        </h4>
        <div className={styles.input_wrapper}>
          <span className={cn(styles.input_label, 'text-p-2')}>
            {t('payment.treeDonate.rangeLabel')}
          </span>
          <A_Input
            label={t('payment.treeDonate.amountLabel')}
            value={amount}
            onChange={handleAmountChange}
            background='gray'
          />
        </div>
      </div>
      <W_PaymentActions
        remainingTime={remainingTime}
        requestId={requestId}
        isAmountValid={isAmountValid(amount)}
      />
      <C_PaySystems />
    </div>
  );
}
